import { Box, Typography } from "@mui/material";
import ActiveClientsTable from "./table";

const ActiveClientsPage = () => {
  return (
    <Box p={"30px"}>
      <Typography mb={4} fontSize={"22px"} fontWeight={600}>
        Active Clients
      </Typography>
      <ActiveClientsTable />
    </Box>
  );
};

export default ActiveClientsPage;
